import { render, staticRenderFns } from "./powered-by.vue?vue&type=template&id=b03d4e0e&scoped=true"
import script from "./powered-by.vue?vue&type=script&lang=js"
export * from "./powered-by.vue?vue&type=script&lang=js"
import style0 from "./powered-by.vue?vue&type=style&index=0&id=b03d4e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03d4e0e",
  null
  
)

export default component.exports